module.exports = __webpack_public_path__ + "img/ff-logo-large-opaque-dark.a549489.svg";